module.exports = __webpack_public_path__ + "static/media/toysat.65787aee.jpg";